import { css } from 'glamor';

export default css({
  flexShrink: 0,
  overflow: 'hidden',
  transition: 'width 250ms cubic-bezier(0.25, 0.1, 0.25, 1)',
});
